export default __webpack_public_path__ + "static/media/01_Kom_Oxwood.5b9ade21.jpg";